import { Box, Image, Text } from "@chakra-ui/react";
import React, { useEffect } from "react";
import Carousel from "react-multi-carousel";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { getTrendingInvitation } from "../../../../Redux/App/action";

const responsive = {
  superLargeDesktop: {
    breakpoint: { max: 4000, min: 3000 },
    items: 3,
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 3,
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 3,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
  },
};

const TInvitationCard = () => {
  const dispatch = useDispatch();
  const { trendingInvitation } = useSelector((store) => store.appReducer);
  useEffect(() => {
    dispatch(getTrendingInvitation);
  }, [dispatch]);
  return (
    <Box w="100%">
      <Carousel responsive={responsive} className="z-0">
        {trendingInvitation &&
          trendingInvitation.map((el, i) => (
            <Link key={i} to={`/customizeInvitation/${el.sourceMediaId}`}>
              <Image src={el.preview} w={{ md: "90%", base: "95%" }} />
              <Text
                color={"white"}
                fontWeight={"semibold"}
                fontSize={{ md: 14, base: 16 }}
                mt={1}
                lineHeight="tight"
                noOfLines={1}
              >
                {el.data[0].cardName}
              </Text>
            </Link>
          ))}
      </Carousel>
    </Box>
  );
};

export default TInvitationCard;
